import { useNavigate } from 'react-router-dom';
import { IconChevronDown, IconUser } from '@tabler/icons';
import { MoonStars, Sun, Logout, Ghost, GhostOff } from 'tabler-icons-react';
import { Group, Text, Menu, UnstyledButton, useMantineColorScheme, Box } from '@mantine/core';
import { useIntlLight } from '../../libs/i18n';
import useGlobalModal from '../../libs/ui-atoms/hooks/useGlobalModal';
import { useImpersonation } from '../../services/auth';
import css from './Header.module.css';
import useAuth from '../../hooks/useAuth';
import { ImpersonationModal } from '../../modules/user/components/modal';

export default function UserMenu() {
  const { t } = useIntlLight();
  const { open, close } = useGlobalModal();
  const navigate = useNavigate();
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const { attestraUser, exitImpersonation, isImpersonating, loggedIn, logout, user } = useAuth();
  const { enableImpersonation } = useImpersonation();

  if (!attestraUser && !loggedIn && !user) {
    return <div />;
  }

  const name =
    !loggedIn && attestraUser
      ? `${attestraUser?.given_name} ${attestraUser?.family_name}`
      : user?.name;
  const email = !loggedIn && attestraUser ? attestraUser?.email : user?.email;

  return (
    <Menu shadow="md" width={200} position="bottom-end" withinPortal>
      <Menu.Target>
        <UnstyledButton className={css.user}>
          <Group>
            <Box sx={{ flex: 1 }}>
              <Text size="sm" weight={500}>
                {name}
              </Text>
              <Text color="dimmed" size="xs">
                {email}
              </Text>
            </Box>
            <IconChevronDown size={14} stroke={1.5} />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        {enableImpersonation && (
          <>
            <Menu.Label>{t('auth.impersonation')}</Menu.Label>
            {isImpersonating ? (
              <Menu.Item
                color="red"
                icon={<GhostOff size={16} />}
                onClick={() => exitImpersonation()}
              >
                {t('app.remove')}
              </Menu.Item>
            ) : (
              <Menu.Item
                color="blue"
                icon={<Ghost size={16} />}
                onClick={() => open?.(<ImpersonationModal onClose={() => close?.()} />)}
              >
                {t('auth.impersonate')}
              </Menu.Item>
            )}
            <Menu.Divider />
          </>
        )}
        <Menu.Label>{t('userMenu.profile')}</Menu.Label>
        <Menu.Item icon={<IconUser size={16} />} onClick={() => navigate('/profile')}>
          {t('userMenu.viewProfile')}
        </Menu.Item>
        <Menu.Divider />
        <Menu.Label>{t('userMenu.settings')}</Menu.Label>
        <Menu.Item
          icon={colorScheme === 'dark' ? <Sun size={16} /> : <MoonStars size={16} />}
          onClick={() => toggleColorScheme()}
        >
          {t(colorScheme === 'dark' ? 'userMenu.lightMode' : 'userMenu.darkMode')}
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item icon={<Logout size={16} />} onClick={() => logout()}>
          {t('auth.signOut')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
